import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dac-baa',
  templateUrl: './baa.component.html',
  styleUrls: ['./baa.component.scss']
})
export class BaaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/baa/baa.component.ts